import type { WorkspaceRole } from '@routr/shared'
export type { WorkspaceRole }
const ROLE_RANK: Record<WorkspaceRole, number> = { MEMBER: 1, ADMIN: 2, OWNER: 3 }
export const roleAtLeast = (role: WorkspaceRole, min: WorkspaceRole) => ROLE_RANK[role] >= ROLE_RANK[min]
export const ROLE_LABELS: Record<WorkspaceRole, string> = { OWNER: 'Owner', ADMIN: 'Admin', MEMBER: 'Member' }
